import i18n from '../VueI18n'

/**
 *
 * @param {Object} solo Solo que deve ser validado
 * @param {Array<Object>} solos Lista de solos que devem ser usados para validacao
 */
const validarSolo = (solo, solos) => {
	if (!isUnique(solo, solos)) {
		return {
			isValid: false,
			message: `${i18n.t('aSigla')} "${solo.tpsl_nm_sigla}" ${i18n.t('jaPertenceSoloCadastrado')}`,
		}
	}
	return { isValid: true }
}

/**
 * Valida se o solo possui valores unicos considerando:
 * - tpsl_nm_sigla
 * @param {Object} solo Plantio que deve ser validado
 * @param {Array<Object>} solos Lista de solos que devem ser usados para validacao
 */
function isUnique(solo, solos) {
	return (
		solos.filter((soloDaLista) => soloDaLista.tpsl_nm_sigla === solo.tpsl_nm_sigla).length === 0
	)
}

export default validarSolo
